interface TelegramWebApp {
  initData: string;
  ready(): void;
}

interface TelegramWindow {
  Telegram?: {
    WebApp?: TelegramWebApp;
  };
}

export interface TelegramMiniAppLaunch {
  initData: string;
}

export function readTelegramMiniAppLaunch(
  source: TelegramWindow = window as unknown as TelegramWindow
): TelegramMiniAppLaunch | null {
  const webApp = source.Telegram?.WebApp;
  if(!webApp) return null;

  webApp.ready();
  return webApp.initData ? {initData: webApp.initData} : null;
}
